"use strict";

(function (H) {

	/*create menu*/
	H.wrap(H.Series.prototype, 'init', function (proceed, chart, options) {
		proceed.apply(this, Array.prototype.slice.call(arguments, 1));
		var serie = this,
		    options = serie.options;

		var menuCnt = $('<div class="iChart-Popup"><div id="iChart-serie-edit-menu" class="iChart-serie-menu"><div class="iChart-serie-menu-header" style="border-color: ' + serie.color + ';"></div><div class="iChart-serie-menu-content"></div></div></div>')
		
		if(isDarkMode == true){
			menuCnt = $('<div class="iChart-Popup"><div id="iChart-serie-edit-menu" class="dark-iChart-serie-menu iChart-serie-menu"><div class="iChart-serie-menu-header" style="border-color: ' + serie.color + ';"></div><div class="iChart-serie-menu-content"></div></div></div>')
		}

		var menu = {
			id: generateUniqueId(),
			cnt: menuCnt,
			destroy: function destroy() {
				this.cnt.empty().remove();
			},
			show: function show(pos) {
				//this.cnt.show();
			},
			hide: function hide() {
				this.cnt.hide();
			},
			toggle: function toggle(pos) {
				_th.chart.navigationBindings.deselectAnnotation()
				$(".optionsY-y_axis_main").hide()
				if (pos) {
					pos.top -= this.cnt.outerHeight();
					this.cnt.css(pos);
				}
				this.cnt.toggle();
			}
		};

		/*build header*/
		menu.cnt.find('.iChart-serie-menu-header').append('<span class="iChart-title" style="color: ' + serie.color + '">' + serie.options.fullname + '</span>').append($('<span class="iChart-close"> X </span>').on('click', function (e) {
			e.preventDefault();
			menu.hide();
		}));

		var contentCnt = menu.cnt.find('.iChart-serie-menu-content');

		/*pick color*/
		var a = $('<a href="#" class="iChart-menu-color" style="display:none;background-color: ' + options.color + ';"></a>');

		var colors = chart.options.colors,
		pickColor = function pickColor(e) {
			e.preventDefault();
			var color = $(this).attr('data-color');

			$(".square."+options.id.replace(":", "")).css({"background-color": color});
			$("#Label-"+options.id.split(":")[0]).css({'background-color': color});
			$("#closeLine-"+options.id.split(":")[0]).css({'stroke': color});

			if (options.type != 'ohlc' && options.type != 'candlestick') {
				options.events.onOptionsChange({ 'color': color });
			} 
			else {
				options.events.onOptionsChange({ 'color': '#EF5350' });
			}

			saveUserSelections[options.id].color = color;
		},
		sqrStyle = `margin-right: 2px; border-radius: 4px;`,
		a1 = $('<a href="#" data-color="' + colors[1] + '" class="iChart-menu-color" style="background-color: ' + colors[1] + ';' +sqrStyle+ '"></a>').on('click', pickColor),
		a2 = $('<a href="#" data-color="' + colors[2] + '" class="iChart-menu-color" style="background-color: ' + colors[2] + ';' +sqrStyle+ '"></a>').on('click', pickColor),
		a3 = $('<a href="#" data-color="' + colors[3] + '" class="iChart-menu-color" style="background-color: ' + colors[3] + ';' +sqrStyle+ '"></a>').on('click', pickColor),
		a4 = $('<a href="#" data-color="' + colors[4] + '" class="iChart-menu-color" style="background-color: ' + colors[4] + ';' +sqrStyle+ '"></a>').on('click', pickColor),
		a5 = $('<a href="#" data-color="' + colors[5] + '" class="iChart-menu-color" style="background-color: ' + colors[5] + ';' +sqrStyle+ '"></a>').on('click', pickColor),
		a6 = $('<a href="#" data-color="' + colors[6] + '" class="iChart-menu-color" style="background-color: ' + colors[6] + ';' +sqrStyle+ '"></a>').on('click', pickColor),
		a7 = $('<a href="#" data-color="' + colors[7] + '" class="iChart-menu-color" style="background-color: ' + colors[7] + ';' +sqrStyle+ '"></a>').on('click', pickColor);

		contentCnt.append(a).append(a1).append(a2).append(a3).append(a4).append(a5).append(a6).append(a7);

		function uniqueTypes(value, index, self) {
			return self.indexOf(value) === index;
		}

		/*pick type, pick axis*/
		var allowedTypes = options.allowedTypes ? options.allowedTypes.filter( uniqueTypes ) : ['line'],
		    compare = options.compare ? options.compare : 'none';

		/****** INVERT SETTING STARTS ******/
		
		function checkMarginsOnCompare(where){
			neutralAxisMargin= false;
			mainAxisMargin= false;
			secondaryAxisMargin = false;

			for(let checkSerie of _th.chart.series){
				if(checkSerie.options.id != 'null:cur'){
					if(checkSerie.options.yAxis == 'y_axis_main'){ mainAxisMargin = true};
					if(checkSerie.options.yAxis == 'y_axis_2'){secondaryAxisMargin = true};
					if(checkSerie.options.yAxis == 'yaxis_n') {neutralAxisMargin = true};
				}		
			}
			if(where !='delete'){
				skipAPI = true
				_th.fireEvent('onOptionsChange');

				_th.build(function () {
					updateChartMenu.call(_th);
				});
			}	
	}

		var thisID = options.id;
		var axisPickWrapper = $('<div class="axisPickWrapper"></div>')
		var axis_l = $('<span id="invertL-'+thisID+'" data-color="' + options.color + '" data-type="leftAxis">' + (SVG_ICONS['leftAxis']) + '</span>')

		if(isDarkMode == true){
			axis_l.addClass('dark-iChart-axis')
		}else{
			axis_l.addClass('iChart-axis')
		}
		
		
		axis_l.on('click', function (e) {
			e.preventDefault();
			resetAnnotations(true)
			for (var i in chart.series)
			{
				if (chart.series[i].userOptions.id == thisID)
				{
					var thisIndex = chart.series[i].index;

					chart.series[thisIndex].update({
						yAxis: 'y_axis_2'
					});
					saveUserSelections[thisID].yaxis = 'y_axis_2';
					checkMarginsOnCompare('null')
				}
			}
		})

		var axis_n = $('<span id="invertN-'+thisID+'" data-color="' + options.color + '" data-type="leftAxis">' + (SVG_ICONS['neutralAxis']) + '</span>')
		
		if(isDarkMode == true){
			axis_n.addClass('dark-iChart-axis')
		}else{
			axis_n.addClass('iChart-axis')
		}
		
		axis_n.on('click', function (e) {
			e.preventDefault();
			resetAnnotations(true)
			for (var i in chart.series)
			{
				if (chart.series[i].userOptions.id == thisID)
				{
					var thisIndex = chart.series[i].index;

					chart.series[thisIndex].update({
						yAxis: 'yaxis_n'
					});
					saveUserSelections[thisID].yaxis = 'yaxis_n';
					checkMarginsOnCompare('null')
				}
			}
		})

		var axis_r = $('<span id="invertR-'+thisID+'" data-color="' + options.color + '" data-type="leftAxis">' + (SVG_ICONS['rightAxis']) + '</span>')
		
		if(isDarkMode == true){
			axis_r.addClass('dark-iChart-axis')
		}else{
			axis_r.addClass('iChart-axis')
		}
		
		
		axis_r.on('click', function (e) {
			e.preventDefault();
			resetAnnotations(true)
			for (var i in chart.series)
			{
				if (chart.series[i].userOptions.id == thisID)
				{
					var thisIndex = chart.series[i].index;

					chart.series[thisIndex].update({
						yAxis: 'y_axis_main'
					});
					saveUserSelections[thisID].yaxis = 'y_axis_main';
					checkMarginsOnCompare('null')
				}
			}
		})

		axisPickWrapper.append(axis_l);
		axisPickWrapper.append(axis_n);
		axisPickWrapper.append(axis_r);

		window.onresize = function() { 
			if (nSeriesGlobal > 2)  {
				$(".iChart-plotLabel").hide(); 
				$('.closeLine').hide();
			}else{
				$(".iChart-plotLabel").show(); 
				$('.closeLine').show();
			}
		}
		/****** INVERT SETTING ENDS ******/
		/****** CHART TYPES STARTS ******/
		if (allowedTypes.length > 0) {
			var typesCnt = $('<div class="iChart-serie-menu-types"></div>');
			menu.types = typesCnt;

			for (var i = 0; i < allowedTypes.length; i++) {

				if (all_serires.length >= 2 && (allowedTypes[i] == "ohlc" || allowedTypes[i] == "candlestick"))
					continue;

				var t = allowedTypes[i];

				var aux = $('<span data-color="' + options.color + '" data-type="' + t + '">' + 
				// (SVG_ICONS['chart_' + t] || t) + '</span>')
				(`${!isMobile? SVG_ICONS[t + '_chart'] : SVG_ICONS[t + '_chart_mobile']}` || t) + '</span>')
				
				if(isDarkMode == true){
					aux.addClass('dark-iChart-type')
				}else{
					aux.addClass('iChart-type')
				}

				aux.on('click', function (e) {

					e.preventDefault();
					saveAnnotationsAutomatically(false)
					var type = $(this).attr('data-type'); 
					
					if (options.events.onOptionsChange) {
						options.events.onOptionsChange({ 'type': type });
					} else {
						serie.update('type', type);
					}
				});

				if (options.type == t) {
					if(isDarkMode == true){
						aux.addClass('dark-iChart-active')
					}else{
						aux.addClass('iChart-active');
					}
				}
		
				typesCnt.append(aux);
			}
		}
		/****** CHART TYPES ENDS ******/
		/****** DELETE OPTION STARTS ******/
		if(isDarkMode == true){
			var deleteCnt = $('<div class="dark-iChart-delete"></div>')
		}else{
			var deleteCnt = $('<div class="iChart-delete"></div>')

		}
		
		deleteCnt.append($('<span>' + SVG_ICONS[/*'trash'*/'delete'] + '</span>').on('span click', function (e) {
			if ($("#diffLabels").is(":visible") && _th.config.cdata.compareNumber >= 2) {
				$("#diffLabels").remove()
			}
			saveAnnotationsAutomatically(true);
			//$('.iChart-menu-cnt-labels').removeClass('disabled');
			$('#iChartHeader-interval-button').removeClass('disabled');
			$('#iChartHeader-type-button').removeClass('disabled');
			$('.iChart-headerLabel-name-input').removeClass('disabled');
			$('#iChart-bodyLabels-cnt2').hide();
			$('#eventsBtn').removeClass('disabled');
			$('#dark-eventsBtn').removeClass('disabled');
			if (options.events.onremoveclick) {
				options.events.onremoveclick(options.id);
			} 
			else {
				serie.remove();
			}
			checkMarginsOnCompare('delete')
		}));

	
		contentCnt.append(axisPickWrapper);
		contentCnt.append(typesCnt);
	
		if (!options.hideDelete && serie.userOptions.isMain != true ) {
			contentCnt.append(deleteCnt);
		}


		$(this.chart.container).closest('.iChart-wrapper').append(menu.cnt);

		this.menu = menu;
	});

	/****** DELETE OPTIONS ENDS ******/
	H.wrap(H.Series.prototype, 'remove', function (proceed, chart, options) {

		if (this.menu) {
			var id = this.menu.id;
			this.menu.destroy();
			$(document).unbind('click.' + id);
			delete this['menu'];
		}

		proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	});
})(Highcharts);

function updateTextAnnotation(setting, annotationSelected, indicatorColor) {
	let updateOptions = {}
	if (setting == 'font size') {
		updateOptions.style = {fontSize: isDarkMode==true ? $("#dark-inputIndicatorModal").val() + "px" : $("#inputIndicatorModal").val() + "px"}
	} else if (setting == 'text color') {
		updateOptions.style = {color: indicatorColor}
	} else if (setting == 'background color') {
		updateOptions = {backgroundColor: indicatorColor}
	}
	annotationSelected.update({labels: updateOptions})
}

function setTextAnnotationContent(txt, annotationSelected) {
	annotationSelected.update({labels: {text: txt}})
}

function addTextAnnotationPopup (annotationSelected = _th.chart.annotations[_th.chart.annotations.length-1], xPos = mouseX, yPos = mouseY) {
	let div = document.createElement('div')
	let {right: chartRight, bottom: chartBottom, left: chartLeft, top: chartTop} = document.querySelector('.iChart-wrapper').getBoundingClientRect()
	isDarkMode ? div.classList.add('textannotation-popup-dark') : div.classList.add('textannotation-popup')
	let title = document.createElement('p')
	title.classList.add('textannotation-popup-title')
	title.style.cursor = 'move'
	title.style.padding = '5px'
	let input = document.createElement('textarea')
	input.autofocus = "true"
	input.value = annotationSelected.userOptions.labels[0].text.replace(/<br>/g, '\n')
	let initAnnotationText = annotationSelected.userOptions.labels[0].text
	previousAnnotationSelected = annotationSelected
	previousAnnotationText = annotationSelected.userOptions.labels[0].text
	input.classList.add('textannotation-input')
	input.addEventListener('input', (e) => {
		setTextAnnotationContent(e.target.value.replace(/\n/g, '<br>'), annotationSelected)
	})
	let okBtn = document.createElement('button')
	okBtn.innerText = 'OK'
	okBtn.addEventListener('click', function (e) {
		previousAnnotationSelected = null
		previousAnnotationText = ''
		removeTextAnnotationPopup()
		if ($(".draw-textannotation-active").is(":visible")) {
			$("#iChartHeader-annotationPicker-button").removeClass("draw-textannotation-active")	
			$("#control-bar-wrapper").css("display","block")
		}
	})
	let cancelBtn = document.createElement('button')
	cancelBtn.innerText = 'Cancel'
	cancelBtn.addEventListener('click', function (e) {
		setTextAnnotationContent(initAnnotationText, annotationSelected)
		previousAnnotationSelected = null
		previousAnnotationText = ''
		removeTextAnnotationPopup()
		if ($(".draw-textannotation-active").is(":visible")) {
			$("#iChartHeader-annotationPicker-button").removeClass("draw-textannotation-active")	
			$("#control-bar-wrapper").css("display","block")
		}
	})
	let btnDiv = document.createElement('div')
	div.appendChild(title)
	div.appendChild(input)
	btnDiv.appendChild(okBtn)
	btnDiv.appendChild(cancelBtn)
	btnDiv.classList.add('textannotation-popup-btnDiv')
	div.appendChild(btnDiv)
	yPos = chartBottom - 180 < yPos + 180 ? yPos - chartTop - 180 : yPos - chartTop + 15
	xPos = chartRight < xPos + 230 ? xPos - chartLeft - 230 : xPos - chartLeft + 15
	div.style.left = xPos + 'px'
	div.style.top = yPos + 'px'
	let overlay = document.createElement('div')
	overlay.classList.add('textannotation-overlay')
	document.querySelector('.iChart-wrapper').appendChild(overlay)
	document.querySelector('.iChart-wrapper').appendChild(div)
	dragElement(div, '.textannotation-popup-title')
}
function removeTextAnnotationPopup () {
	if (document.querySelector('.textannotation-popup')) {
		document.querySelector('.iChart-wrapper').removeChild(document.querySelector('.textannotation-popup'))
	}
	if (document.querySelector('.textannotation-popup-dark')) {
		document.querySelector('.iChart-wrapper').removeChild(document.querySelector('.textannotation-popup-dark'))
	}
	if (document.querySelector(".textannotation-overlay")) {
		document.querySelector('.iChart-wrapper').removeChild(document.querySelector(".textannotation-overlay"))
	}
	if ((document.querySelector('.textannotation-popup') || document.querySelector('.textannotation-popup-dark')) && previousAnnotationSelected && previousAnnotationText) {
		setTextAnnotationContent(previousAnnotationText, previousAnnotationSelected)
	}
}

//Make the text annotation pop-up draggable
function dragElement(elmnt, qSelector) {
	let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
	if (document.querySelector(qSelector)) {
		/* if present, the header is where you move the DIV from:*/
		document.querySelector(qSelector).onmousedown = dragMouseDown;
	} else {
	  /* otherwise, move the DIV from anywhere inside the DIV:*/
	  elmnt.onmousedown = dragMouseDown;
	}
  
	function dragMouseDown(e) {
	  e = e || window.event;
	  e.preventDefault();
	  // get the mouse cursor position at startup:
	  pos3 = e.clientX;
	  pos4 = e.clientY;
	  document.onmouseup = closeDragElement;
	  // call a function whenever the cursor moves:
	  document.onmousemove = elementDrag;
	}
  
	function elementDrag(e) {
	  e = e || window.event;
	  e.preventDefault();
	  // calculate the new cursor position:
	  pos1 = pos3 - e.clientX;
	  pos2 = pos4 - e.clientY;
	  pos3 = e.clientX;
	  pos4 = e.clientY;
	  // set the element's new position:
	  elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
	  elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
	}
  
	function closeDragElement() {
	  /* stop moving when mouse button is released:*/
	  document.onmouseup = null;
	  document.onmousemove = null;
	}
}
function formatTextForExport(str, addSpace) {
	const strArr = str.split('<br>')
	if (addSpace == true) {
	  if (strArr.length < 2) {
		const spaceRegExp = new RegExp(" ")
		if (spaceRegExp.test(strArr[0])) {
			return strArr[0] + '&nbsp;&nbsp;&nbsp;'
		} else {
			return strArr[0] + ' &nbsp;&nbsp;'
		}
	  } else {
		const newStrArr = strArr.map((el) => {
		  return el = el + '&nbsp;&nbsp;&nbsp;'
		})
		return newStrArr.join('<br>')
	  }
	} else {
	  return str.replace(/&nbsp;/g, "")
	}
}
function getInvSeriesIndex(seriesArr) {
	return seriesArr.findIndex(el => el.userOptions.id == 'null:cur')
}
function saveAnnotationsAfterFlags(){
	_th.chart.navigationBindings.deselectAnnotation();
	annotationsForFlags = {}
	console.log(_th.chart.annotations);
	for(let annot in _th.chart.annotations){
		//handle text annotations
		if (_th.chart.annotations[annot].userOptions.langKey.toLowerCase() == 'label') {
			annotationsForFlags[annot] = {
				"langKey":  _th.chart.annotations[annot].userOptions.langKey,
				"type": _th.chart.annotations[annot].userOptions.type,
				"labels": _th.chart.annotations[annot].userOptions.labels,
			}
			continue
		}
		annotationsForFlags[annot] = {
			"point0": _th.chart.annotations[annot].userOptions.typeOptions.points[0], 
			"point1": _th.chart.annotations[annot].userOptions.typeOptions.points[1],
			"shapeOptions":  _th.chart.annotations[annot].userOptions.shapeOptions,
			"line" :	_th.chart.annotations[annot].userOptions.typeOptions.line ? _th.chart.annotations[annot].userOptions.typeOptions.line : null
		}
	}
	console.log('annotationsForFlags');
	console.log(annotationsForFlags);
}
function recreateAnnotationAfterFlags() {
	for (let index in annotationsForFlags) {
	  //handle text annotations
	  if (annotationsForFlags[index].langKey) {
		  if (annotationsForFlags[index].langKey.toLowerCase() == 'label') {
			  let newTextAnnotation = {
				  langKey: annotationsForFlags[index].langKey,
				  type: annotationsForFlags[index].type,
				  labels: annotationsForFlags[index].labels,
				  events: {
					  contextmenu: function (e) {
						e.preventDefault();
						e.stopPropagation();
						// buildContextMenu(e.clientX, e.clientY, this);
						addContextMenuWithDots('label', this)
						return false;
					  },
					  dblclick: function(e) {
						  e.preventDefault();
						  if (this.userOptions) {
							  if (this.userOptions.langKey) {
								  if (this.userOptions.langKey.toLowerCase() == 'label') {
									  addTextAnnotationPopup(this)
								  }
							  }
						  }
					  }
				  },
			  }
			  _th.chart.addAnnotation(newTextAnnotation, true)
			  continue
		  }
	  }
  
	  var newAnnotation = {
		langKey: "Trending Line",
		type: "crookedLine",
		typeOptions: {
		  points: [
			{
			  x: annotationsForFlags[index].point0.x,
			  y: annotationsForFlags[index].point0.y,
			  xAxis: 0,
			  yAxis: 0,
			},
			{
			  x: annotationsForFlags[index].point1.x,
			  y: annotationsForFlags[index].point1.y,
			  xAxis: 0,
			  yAxis: 0,
			},
		  ],
		},
		shapeOptions: {
		  stroke: annotationsForFlags[index].line !== null ? (annotationsForFlags[index].line.hasOwnProperty('stroke') ? annotationsForFlags[index].line.stroke : annotationsForFlags[index].shapeOptions.stroke) : annotationsForFlags[index].shapeOptions.stroke,
		  strokeWidth: annotationsForFlags[index].line !== null ? (annotationsForFlags[index].line.hasOwnProperty('strokeWidth') ? annotationsForFlags[index].line.strokeWidth : annotationsForFlags[index].shapeOptions.strokeWidth) : annotationsForFlags[index].shapeOptions.strokeWidth ,
		},
		events: {
		  contextmenu: function (e) {
			e.preventDefault();
			e.stopPropagation();
			// buildContextMenu(e.clientX, e.clientY, this);
			addContextMenuWithDots('line', this)
			return false;
		  },
		},
	  };
	  _th.chart.addAnnotation(newAnnotation, true);
	}
	console.log('annotations created after flags');
  }
  function addTooltip (data, xPos, yPos, colour) {
	let div = document.createElement('div')
	let {right: chartRight, width: chartWidth, bottom: chartBottom, left: chartLeft, top: chartTop, height: chartHeight} = document.querySelector('.iChart-wrapper').getBoundingClientRect()
	div.classList.add('flag-tooltip')
	div.id = "flag_tooltip"
	div.style.backgroundColor = isDarkMode? "rgb(49,49,49)" : shadeColor2(colour, 0.95)
	div.style.borderColor = shadeColor2(colour, 0.7)
	div.innerHTML = data;
	if (yPos - 130 < 0) {
		yPos = yPos + 35
		div.style.top = yPos + 'px'
	} else {
		div.style.bottom = chartHeight - yPos + 'px'
	}
	if (xPos - 65 < 0 ){
		xPos = 5
		div.style.left = xPos + 'px'
	} else if(xPos + 65 > chartWidth ){
		xPos = chartWidth - 5
		div.style.right = xPos + 'px'
	} else {
		xPos = xPos - 65
		div.style.left = xPos + 'px'
	}
	document.querySelector('.iChart-wrapper').appendChild(div)
}
//New context menu for trendlines and flag series
function addContextMenuWithDots (type, obj, xPos = mouseX, yPos = mouseY) {
	const div = document.createElement('div')
	const {right: chartRight, bottom: chartBottom, left: chartLeft, top: chartTop} = document.querySelector('.iChart-wrapper').getBoundingClientRect()
	isDarkMode ? div.classList.add('context-menu-dots-dark', 'context-menu-dots') : div.classList.add('context-menu-dots')
	const dots = document.createElement('span')
	dots.innerHTML = (SVG_ICONS['three_dots_vertical']) + (SVG_ICONS['three_dots_vertical'])
	dots.classList.add('dots-for-ctxmenu')
	dots.style.cursor = 'move !important'
	// dots.style.padding = '5px'
	div.appendChild(dots)
	const delBtn = document.createElement('span')
	delBtn.innerHTML = (SVG_ICONS['delete'])
	delBtn.classList.add('del-for-ctxmenu')
	delBtn.style.cursor = 'pointer'
	delBtn.title = 'Delete'
	// delBtn.style.padding = '5px'
	if (type == 'line') {
		obj.graphic.element.hcEvents.click[0].fn(obj);
		let indicatorColor = obj.options.typeOptions? obj.options.typeOptions.line.stroke : undefined
		const width = document.createElement('span')
		width.classList.add('stroke-width-menu-dots')
		if (isDarkMode) {
			width.classList.add('stroke-width-menu-dots-dark')
		}
		width.innerHTML = '<span class="width-span" style="height:2px; width: 30px; transform: translateY(-15px)"></span>'
		width.title = 'Stroke width'
		width.addEventListener('click', (e) => {
			e.preventDefault()
			$('.annotationColours').remove()
			// if (!$('.inputDiv')[0]) {
			// 	const input = $(`<input id=` + (isDarkMode == true ?  "dark-inputIndicatorModal": "inputIndicatorModal") + ` class="contextInput" min="1" onkeydown="return false" step="1" type="number" value="` + obj.options.typeOptions.line.strokeWidth +`"/>`).on("change", (e)=>{
			// 		updateTrendingLine('width', obj, 'annotation', indicatorColor)
			// 		width.innerHTML = '— ' + (isDarkMode==true ? $("#dark-inputIndicatorModal").val() : $("#inputIndicatorModal").val()) + 'px'
			// 	})
			// 	const inputDiv = $(`<div class="${isDarkMode? "inputDiv-dark " : ""} inputDiv"></div>`)
			// 	inputDiv.append(input)
			// 	$('.context-menu-dots').append(inputDiv)
			// } else {
			// 	$('.inputDiv').remove()
			// }
			if (!$('.lineWidth')[0]) {
				const divModalWidth = $(`<div class="${isDarkMode? "lineWidth-dark " : ""} lineWidth"></div>`)
				const widthArraysInd = [1, 2, 3, 4]
				for(let width of widthArraysInd){
					let indicatorW = $('<a id="width-'+width+'" class ="width-square"><span class="width-span" style="height:' + width + 'px;"></span></a>').click(function(e){
						updateTrendingLine('width', obj, 'annotation', indicatorColor, width)
					})
					divModalWidth.append(indicatorW)
				}
				$('.context-menu-dots').append(divModalWidth)
			} else {
				$('.lineWidth').remove()
			}

		})
		div.appendChild(width)
		const pallete = document.createElement('span')
		pallete.classList.add('pallete-menu-dots')
		pallete.style.cursor = 'pointer'
		pallete.innerHTML = SVG_ICONS['colour_pallete']
		pallete.title = 'Color'
		pallete.addEventListener('click', (e) => {
			e.preventDefault()
			$('.inputDiv').remove()
			$('.lineWidth').remove()
			if (!$('.annotationColours')[0]) {
				const divModalColors = $(`<div class="${isDarkMode? "annotationColours-dark " : ""} annotationColours"></div>`)
				const colorArraysInd = (isDarkMode == true ?['#FFFFFF', '#FFFF99', '#FF5C25', '#FF33FF', '#2F980F', '#E6331A', '#004E95', '#7F20C1', '#9F1010'] : ['#FF5C25', '#FF33FF', '#2F980F', '#E6331A', '#004E95', '#504444', '#7F20C1', '#9F1010', '#130C0C'])
		
				for(let color of colorArraysInd){
					let indicatorC = $('<a id="color-'+color.replace("#",'')+'" class ="color-square" style="background-color: '+color+'"></a>').click(function(e){
						$('#color-'+indicatorColor.replace("#",'')).removeClass( "color-square-active" )
			
						indicatorColor = color
						updateTrendingLine('color', obj, 'annotation', indicatorColor)
						$('#color-'+color.replace("#",'')).addClass('color-square-active')
					})
					divModalColors.append(indicatorC)
				}
				$('.context-menu-dots').append(divModalColors)
			} else {
				$('.annotationColours').remove()
			}
		})
		div.appendChild(pallete)
		const clone = document.createElement('span')
		clone.classList.add('clone-menu-dots')
		clone.style.cursor = 'pointer'
		clone.innerHTML = SVG_ICONS['content_copy']
		clone.title = 'Clone'
		clone.addEventListener('click', (e) => {
			e.preventDefault()
			cloneAnnotation(obj)
			removeContextMenuWithDots()
		})
		div.appendChild(clone)
	}
	if (type == 'label') {
		let indicatorColor = obj.options.typeOptions? obj.options.typeOptions.line.stroke : undefined
		const fontSize = document.createElement('span')
		let size = Number(obj.labels[0].options.style.fontSize.slice(0, -2))
		fontSize.classList.add('font-size-menu-dots')
		fontSize.innerHTML = '<span style="position: relative; bottom: 8px;">Aa ' + size + 'px</span>'
		fontSize.title = 'Font size'
		fontSize.addEventListener('click', (e) => {
			e.preventDefault()
			$('.annotationColours').remove()
			$('.annotationColours2').remove()
			if (!$('.inputDiv')[0]) {
				const input = $(`<input id=` + (isDarkMode == true ?  "dark-inputIndicatorModal": "inputIndicatorModal") + ` class="contextInput" min="1" onkeydown="return false" step="1" type="number" value="` + Number(obj.labels[0].options.style.fontSize.slice(0, -2)) +`"/>`).on("change", (e)=>{
					updateTextAnnotation('font size', obj, indicatorColor)
					fontSize.innerHTML = '<span style="position: relative; bottom: 8px;">Aa ' + (isDarkMode==true ? $("#dark-inputIndicatorModal").val() : $("#inputIndicatorModal").val()) + 'px</span>'
				})
				const inputDiv = $(`<div class="${isDarkMode? "inputDiv-dark " : ""} inputDiv"></div>`)
				inputDiv.append(input)
				$('.context-menu-dots').append(inputDiv)
			} else {
				$('.inputDiv').remove()
			}
		})
		div.appendChild(fontSize)
		const pallete = document.createElement('span')
		pallete.classList.add('pallete-menu-dots')
		pallete.style.cursor = 'pointer'
		pallete.innerHTML = SVG_ICONS['colour_pallete']
		pallete.title = 'Text color'
		pallete.addEventListener('click', (e) => {
			e.preventDefault()
			$('.annotationColours2').remove()
			indicatorColor = obj.labels[0].options.style.color
			$('.inputDiv').remove()
			if (!$('.annotationColours')[0]) {
				const divModalColors = $(`<div class="${isDarkMode? "annotationColours-dark " : ""} annotationColours"></div>`)
				const colorArraysInd = ['#f23645', '#ff9800', '#ffeb3b', '#4caf50', '#089981', '#00bcd4', '#2962ff', '#673ab7', '#9c27b0', '#e91e63', '#ffffff', '#000000']
		
				for(let color of colorArraysInd){
					let indicatorC = $('<a id="color-'+color.replace("#",'')+'" class ="color-square" style="background-color: '+color+'"></a>').click(function(e){
						$('#color-'+indicatorColor.replace("#",'')).removeClass( "color-square-active" )
			
						indicatorColor = color
						updateTextAnnotation('text color', obj, indicatorColor)
						$('#color-'+color.replace("#",'')).addClass('color-square-active')
					})
					divModalColors.append(indicatorC)
				}
				$('.context-menu-dots').append(divModalColors)
			} else {
				$('.annotationColours').remove()
			}
		})
		div.appendChild(pallete)
		const pallete_2 = document.createElement('span')
		pallete_2.classList.add('pallete-menu-dots')
		pallete_2.style.cursor = 'pointer'
		pallete_2.innerHTML = SVG_ICONS['colour_pallete']
		pallete_2.title = 'Background color'
		pallete_2.addEventListener('click', (e) => {
			e.preventDefault()
			$('.annotationColours').remove()
			indicatorColor = "rgba(0, 0, 0, 0.75)"
			$('.inputDiv').remove()
			if (!$('.annotationColours2')[0]) {
				const divModalColors = $(`<div class="${isDarkMode? "annotationColours-dark " : ""} annotationColours2"></div>`)
				const colorArraysInd = ['rgba(242, 54, 54, 0.75)', 'rgba(255, 152, 152, 0.75)', 'rgba(255, 235, 235, 0.75)', 'rgba(76, 175, 175, 0.75)', 'rgba(8, 153, 153, 0.75)', 'rgba(0, 188, 188, 0.75)', 'rgba(41, 98, 98, 0.75)', 'rgba(103, 58, 58, 0.75)', 'rgba(156, 39, 39, 0.75)', 'rgba(233, 30, 30, 0.75)', 'rgba(255, 255, 255, 0.75)', 'rgba(0, 0, 0, 0.75)']
		
				for(let color of colorArraysInd){
					let indicatorC = $('<a id="color-'+color.replace(/[ ,.()#]/g,'')+'" class ="color-square" style="background-color: '+color+'"></a>').click(function(e){
						$('#color-'+indicatorColor.replace(/[ ,.()#]/g,'')).removeClass( "color-square-active" )
			
						indicatorColor = color
						updateTextAnnotation('background color', obj, indicatorColor)
						$('#color-'+color.replace(/[ ,.()#]/g,'')).addClass('color-square-active')
					})
					divModalColors.append(indicatorC)
				}
				$('.context-menu-dots').append(divModalColors)
			} else {
				$('.annotationColours2').remove()
			}
		})
		div.appendChild(pallete_2)
	}
	if (type == 'flag') {
		
		delBtn.addEventListener('click', (e) => {
			const thisFlagcolour = obj.color
			const thisFlagSymbol = obj.userOptions.symbol
			_th.chart.series[obj.index].remove()
			flagSeriesArr.splice(flagSeriesArr.indexOf(thisFlagSymbol), 1)
			flagCount--;
			flagsColourArr.push(thisFlagcolour)
			chartTitle(_th.chart.series)
			removeContextMenuWithDots()
		})
	} else {
		delBtn.addEventListener('click', (e) => {
			e.preventDefault()
			removeIndicator('annotation', obj.clipRect.id)
			removeContextMenuWithDots()
		})
	}
	div.appendChild(delBtn)
	yPos = chartBottom - 50 < yPos + 50 ? yPos - chartTop + 50 : yPos - chartTop - 50
	if (type == 'flag') {
		xPos = chartRight < xPos + 100 ? xPos - chartLeft - 100 : xPos - chartLeft - 20
		div.style.left = xPos + 'px'
	} else {
		div.style.left = '50%'
		div.style.transform = 'translateX(-50%)'
	}
	div.style.top = yPos + 'px'
	let overlay = document.createElement('div')
	overlay.classList.add('dotsmenu-overlay')
	document.querySelector('.iChart-wrapper').appendChild(overlay)
	document.querySelector('.iChart-wrapper').appendChild(div)
	dragElement(div, '.dots-for-ctxmenu')
}
function removeContextMenuWithDots () {
	if (document.querySelector('.context-menu-dots')) {
		document.querySelector('.iChart-wrapper').removeChild(document.querySelector('.context-menu-dots'))
	}
	if (document.querySelector(".dotsmenu-overlay")) {
		document.querySelector('.iChart-wrapper').removeChild(document.querySelector(".dotsmenu-overlay"))
	}
}
function checkIfPercentage (full_name) {
	if (full_name.toLowerCase().indexOf('bond') > -1 || full_name.toLowerCase().indexOf('yield') > -1 || full_name.toLowerCase().indexOf('usvix') > -1) {
		return true
	} else {
		return false
	}
}

function findSeriesIndex (seriesArr, id) {
	return seriesArr.findIndex(el => el.userOptions.id == id)
}
//function to get a shade of a hex colour
function shadeColor2(color, percent) {
	const f = parseInt(color.slice(1),16),
		t = percent<0 ? 0 : 255,
		p = percent<0 ? percent*-1 : percent,
		R = f>>16,
		G = f>>8&0x00FF,
		B = f&0x0000FF;
	return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
}
function buildTechIndicatorsModal(){
	let indicatorColor = '#FF6633'
	const iModalWrapper = div({}, { 'class': isDarkMode? 'iChart-tech-indicators-modal iChart-tech-indicators-modal-dark' :'iChart-tech-indicators-modal' });

	const iModalTitle = div({}, { 'class': 'iChart-tech-indicators-modal-title' });
	const titleModal = $('<span class="techIndicatorModalTitle"></span>');

	const periods = $("<span>Periods: </span>");
	const input = $('<input id="inputTechIndicatorModal" type="number" value="14"/>');
	
	const color = $("<br/><span>Color: </span>");
	const divModalColors = div({}, { 'class': 'iChart-tech-indicators-modal-colors' });

	const colorArraysInd = ['#FF6633', '#FF33FF', '#FFFF99', '#00B3E6', '#99FF99', '#E6331A', '#66994D', '#9900B3', '#99E6E6']

	for(let color of colorArraysInd){
		const indicatorC = $('<a id="color-'+color.replace("#",'')+'" class ="color-square" style="background-color: '+color+'"></a>').click(function(e){
			$('#color-'+indicatorColor.replace("#",'')).removeClass( "color-square-active" )

			indicatorColor = color

			$('#color-'+color.replace("#",'')).addClass('color-square-active')
		})
		divModalColors.append(indicatorC)
	}

	const iModalBtn = div({}, { 'class': 'iChart-tech-indicators-modal-buttons' });
	const submitBtn = $('<button>OK</button>')
	const cancelBtn = $('<button>Cancel</button>')

	submitBtn.click(function(){
		globalPeriod = $("#inputTechIndicatorModal").val()
		$(".iChart-tech-indicators-modal").hide();
		removeIndicator('indicator', idToBeRemovedGlobal)
		buildIndicator(indicatorColor)
	})

	cancelBtn.click(function(){
		indicatorChoosen = undefined
		idToBeRemovedGlobal = null;
		$(".iChart-tech-indicators-modal").hide();
	})
	
	iModalTitle.append(titleModal)
	iModalBtn.append(cancelBtn,submitBtn)

	if(IsDarkMode==true){
		$(iModalWrapper).css("background-color","rgb(65,65,65)")
	}
	
	iModalWrapper.append(iModalTitle, periods, input, color, divModalColors,iModalBtn)
	$(".iChart-wrapper").append(iModalWrapper);
}

function recreateSMA(smaArr) {
	console.log(smaArr);
	smaArr.forEach(el => {
		const colour = el.colour
		const period = el.period
		indicatorChoosen = "sma"
		globalPeriod = period
		buildIndicator(colour)
	})

}

function calculateDiff(series_1, series_2) {
	if (series_1.length && series_2.length) {
		if (series_1[0].y > series_2[0].y) {
			let diffArr = series_1.map((el) => {
				const series_2_el = series_2.find((el2) => {
					return el2.x == el.x
				})
				if (series_2_el){
					return {x: el.x, y: el.y - series_2_el.y}
				}
			})
			diffArr = diffArr.filter((el) => el !== undefined)
			return diffArr
		} else {
			let diffArr = series_2.map((el) => {
				const series_1_el = series_1.find((el2) => {
					return el2.x == el.x
				})
				if (series_1_el){
					return {x: el.x, y: el.y - series_1_el.y}
				}
			})
			diffArr = diffArr.filter((el) => el !== undefined)
			return diffArr
		}
	}
}

function capitaliseString(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}
function getFirstDayOfMonth (timestamp) {
	const date = new Date(timestamp)
	const year = date.getFullYear()
	const month = date.getMonth()
	return new Date(year, month, 1).getTime()
}
function timestampToString(timestamp) {
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	
	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
function getCurrentUTCTime() {
	const now = new Date();
	const hours = now.getUTCHours().toString().padStart(2, '0');
	const minutes = now.getUTCMinutes().toString().padStart(2, '0');
	return `${hours}:${minutes}`;
}
function getBeginningOfYear(timestamp) {
	const date = new Date(timestamp);
	if (!(date.getUTCMonth() === 0 && date.getUTCDate() === 1)) {
	  date.setUTCFullYear(date.getUTCFullYear() + 1);
	  date.setUTCMonth(0);
	  date.setUTCDate(1);
	}
	return date.getTime();
}
function getYearDifference(timestamp1, timestamp2) {
	const date1 = new Date(timestamp1);
	const date2 = new Date(timestamp2);

	const diffInMilliseconds = Math.abs(date1 - date2);
  

	const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
	const millisecondsInWeek = 1000 * 60 * 60 * 24 * 7;
	let diffInYears = 0
	if (_th.config.cdata.compareNumber < 2) {
		diffInYears = diffInMilliseconds / millisecondsInYear;
	} else {
		diffInYears = (diffInMilliseconds + millisecondsInWeek) / millisecondsInYear;
	}
	return Math.floor(diffInYears);
  }